import * as app from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { AppState } from './types';

const defaultState: AppState = {
  latest: {
    versionCode: 36,
    releasedDate: '08/27/2020',
    version: '1.19.0',
  },
  loading: false,
  isUpdated: true,
  installed: {
    versionCode: 36,
    releasedDate: '08/27/2020',
    version: '1.19.0',
  },
};

export type AppActions = ActionType<typeof app>

export default (state = defaultState, action: AppActions): AppState => {
  switch (action.type) {
    case getType(app.fetchApp.request):
      return {
        ...state,
        loading: true,
      }
    case getType(app.fetchApp.success):
      return {
        ...state,
        loading: false,
        latest: {
          ...state.latest,
          ...action.payload,
        },
      }
    default:
      return state;
  }
};
